import axios from "axios";
import {
  USER_SURVEY_REQUEST,
  USER_SURVEY_SUCCESS,
  USER_SURVEY_FAIL,
  USER_SURVEY_CLEAR_ERRORS,
  USER_SURVEY_ANS_REQUEST,
  USER_SURVEY_ANS_SUCCESS,
  USER_SURVEY_ANS_FAIL,
  USER_SURVEY_ANS_CLEAR_ERRORS,
  USER_SURVEY_COMP_REQUEST,
  USER_SURVEY_COMP_SUCCESS,
  USER_SURVEY_COMP_FAIL,
  USER_SURVEY_COMP_CLEAR_ERRORS,
} from "../Constants/user_surveys_constants";

export const get_user_surveys = () => async (dispatch) => {
  try {
    dispatch({
      type: USER_SURVEY_REQUEST,
    });
    const survey = await axios.get(
      `${process.env.REACT_APP_API_URL}/survey/survey_by_user_draft/`
    );
    dispatch({
      type: USER_SURVEY_SUCCESS,
      payload: survey.data.result,
    });
  } catch (error) {
    dispatch({
      type: USER_SURVEY_FAIL,
      payload: error,
    });
  }
};

export const user_survey_clearErrors = () => async (dispatch) => {
  dispatch({
    type: USER_SURVEY_CLEAR_ERRORS,
  });
};

export const add_user_ans_surveys = (user_ans_payload) => async (dispatch) => {
  try {
    dispatch({
      type: USER_SURVEY_ANS_REQUEST,
    });
    const survey = await axios.post(
      `${process.env.REACT_APP_API_URL}/survey/surveyuserans/`,
      user_ans_payload
    );
    dispatch({
      type: USER_SURVEY_ANS_SUCCESS,
      payload: survey.data,
    });
    console.log(survey);
    return survey;
  } catch (error) {
    dispatch({
      type: USER_SURVEY_ANS_FAIL,
      payload: error,
    });
  }
};

export const user_survey_ans_clearErrors = () => async (dispatch) => {
  dispatch({
    type: USER_SURVEY_ANS_CLEAR_ERRORS,
  });
};

// Comp
export const get_user_surveys_comp = () => async (dispatch) => {
  try {
    dispatch({
      type: USER_SURVEY_COMP_REQUEST,
    });
    const survey = await axios.get(
      `${process.env.REACT_APP_API_URL}/survey/survey_by_user_complete/`
    );
    dispatch({
      type: USER_SURVEY_COMP_SUCCESS,
      payload: survey.data.result,
    });
  } catch (error) {
    dispatch({
      type: USER_SURVEY_COMP_FAIL,
      payload: error,
    });
  }
};

export const user_survey_comp_clearErrors = () => async (dispatch) => {
  dispatch({
    type: USER_SURVEY_COMP_CLEAR_ERRORS,
  });
};
